import {Maintenance,type MaintenanceData} from "@/types/Maintenance";
import {MaintenanceVariables} from "@/types/MaintenanceVariables";

export class MaintenanceInfo {
    public a:boolean;
    public m: Maintenance|null;
    public r: MaintenanceVariables;

    constructor(data: MaintenanceInfoData | undefined = undefined) {
        if (data === undefined) {
            this.a = false;
            this.m = null;
            this.r = new MaintenanceVariables();
        } else {
            this.a = data.a;
            this.m = null;
            if(data.m !== undefined && data.m !== null)
            {
                this.m = new Maintenance(data.m);
            }
            this.r = new MaintenanceVariables(data.r);
        }
    }
}


export type MaintenanceInfoData = {
    a: boolean;
    m: MaintenanceData|null;
    r: object;
}